export enum ProjectCustomizationSubTabs {
  APP_AND_WEBAPP = 'app-webapp',
}
